module.exports = __webpack_public_path__ + "img/Thinking.f5c0b637.png";